import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from '@/lib/error/boundary';
import { GenericFallback } from '@/lib/error/generic-fallback';

import { ContextMenuContextProvider } from '../context-menu/context-menu-context-provider';
import { OverlayContextProvider } from '../overlay/overlay-context-provider';
import { Sidebar } from './sidebar';

import { HideInEmbedded } from './hide-in-embedded';

import { useLayoutContext } from './layout-context';

import styles from './sidebar-layout.module.scss';

export const SidebarLayout = () => {
  const { scrollAreaRef } = useLayoutContext();
  return (
    <ContextMenuContextProvider>
      <OverlayContextProvider>
        <div className={styles.layout}>
          <HideInEmbedded>
            <Sidebar />
          </HideInEmbedded>
          <div className={styles.main} ref={scrollAreaRef}>
            <div className={styles.content}>
              <ErrorBoundary
                fallback={({ resetError }) => (
                  <GenericFallback fullscreen resetOnNavigate resetError={resetError} />
                )}>
                <Outlet />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </OverlayContextProvider>
    </ContextMenuContextProvider>
  );
};
